
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-wallet/mobile/how-to-export-view-private-keys-or-and-seed-phrase-in-komodo-wallet-mobile",
      function () {
        return require("private-next-pages/docs/komodo-wallet/mobile/how-to-export-view-private-keys-or-and-seed-phrase-in-komodo-wallet-mobile/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-wallet/mobile/how-to-export-view-private-keys-or-and-seed-phrase-in-komodo-wallet-mobile"])
      });
    }
  